<template lang="pug">
  div.booxi-btn
    a.btn(v-text='text' @click='loadBooxiScript()')
</template>

  <script>
  import secrets from '@/modules/config/secrets'

  export default {
    name: 'BooxiButton',
    props: ['text', 'apiKey'],

    methods: {
      loadBooxiScript () {
        let config = {}
        if (this.apiKey['key'] === '') {
          config = {
            apiKey: secrets.generalBooxiApiKey,
            language: 'eng',
            bookingFlow: 'locations',
            locationCategorySelection: 'required',
            locationTags: 'Sephora'
          }
        } else {
          config = {
            apiKey: this.apiKey['key'],
            language: 'eng'
          }
        }
        window.booxiBookNow(config)
      }
    }

  }
  </script>

  <style scoped lang='scss'>
  .btn {
      max-width: 200px;
      width: 100%;

      @include media-breakpoint-down(tn) {
        max-width: none;
        margin-bottom: 10px;
        font-size: 95%;
      }
    }

    @include media-breakpoint-down(md) {
      .booxi-btn {
        width: 160px;
      }
    }
  </style>
